
<div class="admin-container">
    <div class="overhead-buttons-container">
        <button *ngIf="showUserSyncButton" [disabled]="isSyncing" (click)="startUserSync()" [ngClass]="{'disabled-button': isSyncing}">{{strings["sync"]}}</button>
        <button [disabled]="disableButtons" (click)="save()" [ngClass]="{'disabled-button': !showSaveButton}">{{strings["save"]}}</button>
    </div>
    <div class="controls-container">
        <div class="sub-admin-left-container">
            <div class="users">
                <div class="users-list-container">
                    
                    <span class="users-sub-header">{{strings["users"]}}</span>

                    <div class="search-bar-container">
                        <input class="users-search search-bar" type="text" [placeholder]="strings['search']"
                            [(ngModel)]="searchStringUser" (input)="filterUserList(selectedRole)">
                    </div>
                    <div class="users-table-header-container">
                        <span class="user-name">
                            {{strings["users"]}}
                        </span>
                    </div>
                    <div *ngIf="!selectedRole" class="users-list-item-container">
                        <div class="users-list-item" *ngFor="let user of filteredUsers; let i = index"
                            [class.selected]="user===selectedUser" [ngClass]="{'gray-background': shouldGrayBackground(i)}"
                            (click)="selectUser(user)">
                            {{user.firstName}}
                            {{user.lastName}}
                        </div>
                    </div>
                    <div *ngIf="selectedRole && filteredUsers.length > 0" class="users-list-item-container">
                        <div class="users-list-item" *ngFor="let user of matchingUsers; let i = index"
                            [class.selected]="user===selectedUser" [ngClass]="{'gray-background': shouldGrayBackground(i)}"
                            (click)="selectUser(user)">
                            {{user.firstName}}
                            {{user.lastName}}
                        </div>
                    </div>
                    <div *ngIf="selectedRole && filteredUsers.length > 0" class="seperator-container">
                        <div class="seperator"></div>
                    </div>
                    <div *ngIf="selectedRole" class="users-list-item-container">
                        <div class="users-list-item" *ngFor="let user of nonMatchingUsers; let i = index"
                            [class.selected]="user===selectedUser" [ngClass]="{'gray-background': shouldGrayBackground(i)}"
                            (click)="selectUser(user)">
                            {{user.firstName}}
                            {{user.lastName}}
                        </div>
                    </div>
                </div>
            </div>
            <div class="roles">
                <div class="roles-header-container">
                    <span class="roles-sub-header">{{strings["roles"]}}</span>
                    <div class="roles-title-section-buttons">
                        <button [disabled]="disableButtons" (click)="addRole()">{{strings["addRole"]}}</button>
                        <button
                            [disabled]="!selectedRole || isOwnerRole(selectedRole)"
                            [ngClass]="{'disabled-button': !selectedRole || isOwnerRole(selectedRole)}"
                            [matTooltip]="isOwnerRole(selectedRole) ? strings['ownerRoleCannotBeRenamed'] : null"
                            (click)="editRole()">
                            {{strings["editRole"]}}
                        </button>
                   </div>
                </div>
                <div class="search-bar-container">
                    <input class="roles-search search-bar" type="text" [placeholder]="strings['search']"
                        [(ngModel)]="searchStringRole" (input)="filterRoleList()">
                </div>
                <div class="roles-container">
                    <div class="roles-table-header-container">
                        <span class="role-name">
                            {{strings["roleName"]}}
                        </span>
                        <span class="role-enable">
                            {{strings["enable"]}}
                        </span>
                        <span class="role-expiration-date">
                            {{strings["expirationDate"]}}
                        </span>
                    </div>
                    <div class="column-headers-container-roles">
                        <div class="roles-list-item" *ngFor="let role of filteredRoles; let i = index"
                            [ngClass]="{'gray-background': shouldGrayBackground(i), 'selected': role===selectedRole,'selected-role': role===selectedRole && this.editIndex !=null && this.enableEditing===true}"
                            (click)="selectRole(role)">
                    <div class="role-name-edit-container">
                        <span class="name role-name-display" *ngIf="!isEditingRole(role)">
                            {{ role.name }}
                        </span>

                        <input *ngIf="isEditingRole(role) && !isOwnerRole(role)" class="name"
                            [ngClass]="{'role-name-input-error': isRoleNameDraftInvalid(role)}"
                            [attr.aria-invalid]="isRoleNameDraftInvalid(role)" [ngModel]="editRoleNameDraft"
                            (ngModelChange)="onRoleNameInputChange(role, $event)" (click)="$event.stopPropagation()">

                        <span class="role-name-validation-message" *ngIf="getRoleNameValidationMessage(role) as roleNameValidationMessage">
                            {{ roleNameValidationMessage }}
                        </span>
                    </div>

                    <button class="update-button" *ngIf="isEditingRole(role)" [disabled]="isRoleNameDraftInvalid(role)"
                        [ngClass]="{'disabled-button': isRoleNameDraftInvalid(role)}" (click)="updateEdit($event)">
                        Update
                    </button>
                            <input
                                [matTooltip]="role.id==='_Owner'&& oneOwner===true && role.enable===true? strings['atLeastOneOwner'] : null"
                                class="center-item checkbox" type="checkbox" id="enable"
                                [disabled]="selectedUser == null || (role.id==='_Owner'&& oneOwner===true && role.enable===true)"
                                [(ngModel)]="role.enable" (click)="toggleUserRole(selectedUser, role)">
                            <input class="role-expiration-date" [matTooltip]="strings['showDatePicker']"
                                [ngClass]="{'selected-role-expiration-date': role===selectedRole && this.editIndex !=null && this.enableEditing===true}"
                                type="date" id="expirationDate" [ngModel]="role.expirationDate| date:'yyyy-MM-dd'"
                                (ngModelChange)="role.expirationDate=$event"
                                (change)="toggleUserExpirationDate(selectedUser, role)">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="sub-admin-right-container">
            <div class="right-container-header">
                <span class="permissions-button" [ngClass]="{'highlight-button': selectedTab == 'Permissions'}"
                    (click)="setTab('Permissions')">
                    {{strings["permissions"]}}
                </span>
                <span class="permissions-button" [ngClass]="{'highlight-button': selectedTab == 'FileGroups'}"
                    (click)="setTab('FileGroups')">
                    {{strings["fileGroup"]}}
                </span>
            </div>
            <div class="select-role-text" *ngIf="!selectedRole">{{strings["selectARole"]}}</div>
            <!-- Permissions -->
            <!-- Search Bar -->
            <div class="search-bar-container">
                <input *ngIf="selectedTab == 'Permissions' && selectedRole != null" class="search-bar"
                    type="text" [placeholder]="strings['search']" [(ngModel)]="searchStringPermission"
                    (input)="filterPermissions()">
            </div>
            <div class="permissions-wrapper" *ngIf="selectedTab == 'Permissions' && selectedRole != null">
                <div class="permissions"> 
                    <!-- Security Admin Permissions -->
                    <app-collapsible [title]="strings['securityAdmin']" [open]="false" [titleFontSize]="collapsibleTitleFontSize" [titleBackgroundColor] = "collapsibleTitleColor1" [titleFontWeight]="collapsibleTitleFontWeight">
                        <div class="left-margin-16">
                            <div class="permissions-header-container">
                                <div class="permissions-admin-header-container">
                                    <span class="center-item permission-name">{{strings["securityAdmin"]}}</span>
                                </div>
                            </div>
                            <div class="permissions-header-container">
                                <div class="permissions-admin-header-container">
                                    <input class="center-item checkbox" type="checkbox"
                                        [checked]="selectedRole.permissions.securityAdmin" (click)="toggleSecurityAdmin()"
                                        [disabled]="selectedRole.id=='_Owner'">
                                </div>
                            </div>
                        </div>
                    </app-collapsible> 

                    <!-- Table Permissions -->
                    <app-collapsible [title]="strings['tables']" [open]="true" [titleFontSize]="collapsibleTitleFontSize" [titleBackgroundColor] = "collapsibleTitleColor1" [titleFontWeight]="collapsibleTitleFontWeight">
                        <div class="left-margin-16">
                            <div class="table-permissions-top-controls">
                                <app-permissions-table [fullAccessPermission]="true"></app-permissions-table>
                                <div class="collapse-all-buttons-container">
                                    <button class="collapse-all-button" (click)="setAllTablePermissionCollapse(true)">+</button>
                                    <button class="collapse-all-button" (click)="setAllTablePermissionCollapse(false)">-</button>
                                </div>
                            </div>
                        </div>
                        <app-collapsible 
                        *ngFor="let table of filteredTables"
                        #tableCollapsible
                        [titleBackgroundColor] = "collapsibleTitleColor2"
                        [title]="table.actualName"
                        [titleFontWeight]="collapsibleSubTitleFontWeight">
                            <app-permissions-table 
                                [title]="table.name"
                                [tableId]="table.name">
                            </app-permissions-table>
                        </app-collapsible>
                    </app-collapsible>        

                    <!-- Integration Permissions -->
                    <app-collapsible [title]="strings['integrations']" [open]="true" [titleFontSize]="collapsibleTitleFontSize" [titleBackgroundColor] = "collapsibleTitleColor1" [titleFontWeight]="collapsibleTitleFontWeight">
                        <div class="left-margin-16">   
                            <div class="table-permissions-top-controls">
                                <app-permissions-integration [fullAccessPermission]="true"></app-permissions-integration>
                                <div class="collapse-all-buttons-container">
                                    <button class="collapse-all-button" (click)="setAllIntegrationPermissionCollapse(true)">+</button>
                                    <button class="collapse-all-button" (click)="setAllIntegrationPermissionCollapse(false)">-</button>
                                </div>
                            </div>   
                        </div>
                        
                        <app-collapsible 
                        *ngFor="let integration of filteredIntegrations"
                        #integrationCollapsible
                        [title]="integration.alias || integration.name"
                        [titleBackgroundColor] = "collapsibleTitleColor2"
                        [titleFontWeight]="collapsibleSubTitleFontWeight">
                            <app-permissions-integration 
                                [title]="integration.alias || integration.name"
                                [integration]="integration">
                            </app-permissions-integration>
                        </app-collapsible>
                    </app-collapsible>
                    
                    <!-- Debug Permissions -->
                    <div *ngIf="notProd">
                        <app-collapsible [title]="'Debug'" [open]="false" [titleFontSize]="collapsibleTitleFontSize" [titleBackgroundColor] = "collapsibleTitleColor1" [titleFontWeight]="collapsibleTitleFontWeight">
                            <div class="left-margin-16">  
                                <div class="permissions-admin-header-container">
                                    <div class="center-item permission-name red-text">
                                        Localhost Debugging
                                        <img src="assets/images/icons/info-icon.svg" alt="Info" class="info-icon"
                                            title="This permission is intended ONLY for DIS consultants when debugging.  Enabling this permission can alter expected results when running solutions">
                                    </div>
                                </div>
                                <div class="permissions-admin-header-container">
                                    <input class="center-item checkbox" type="checkbox" [(ngModel)]="localHost" (click)="toggleLocalhost()"
                                    [checked]="selectedRole.permissions.disLocalhostPermission">
                                </div>
                            </div>
                        </app-collapsible>  
                    </div>
                </div>
            </div>
            <!-- File Groups -->
            <div class="file-groups" *ngIf="selectedTab == 'FileGroups' && selectedRole != null">

                <!-- Assigned File Groups -->
                <div class="file-groups-container">
                    <p class="file-groups-header">{{strings["assigned"]}}</p>
                    <div class="file-groups-container-inner">
                        <input class="file-search search-function" type="text" [placeholder]="strings['search']"
                            [(ngModel)]="searchStringAssign" (input)="filterAssignList()">
                        <span *ngFor="let fileGroup of filteredAssignedFiles; let i =index"
                            (click)="toggleFileGroupSelection(fileGroup)"
                            [ngClass]="{'gray-background': shouldGrayBackground(i), 'selected': fileGroup.isSelected}">
                            <div class="file-name">
                                {{fileGroup.name}}
                            </div>
                        </span>
                    </div>
                </div>
                <!-- Assignment Buttons -->
                <div class="arrow-container">
                    <button (click)="RemoveSelectedFileGroupsFromRole()">
                        <img src="../../assets/images/icons/FillchevronRight.svg">
                    </button>
                    <button (click)="AssignSelectedFileGroupsToRole()">
                        <img src="../../assets/images/icons/FillchevronLeft.svg">
                    </button>
                </div>
                <!-- Available File Groups -->
                <div class="file-groups-container">
                    <p class="file-groups-header">{{strings["available"]}}</p>
                    <div class="file-groups-container-inner">
                        <input class="file-search search-function" type="text" [placeholder]="strings['search']"
                            [(ngModel)]="searchStringAvaliable" (input)="filterAvailableList()">
                        <span *ngFor="let fileGroup of filteredAvailableFiles; let i =index"
                            (click)="toggleFileGroupSelection(fileGroup)"
                            [ngClass]="{'gray-background': shouldGrayBackground(i), 'selected': fileGroup.isSelected}">
                            <div class="file-name">
                                {{fileGroup.name}}
                            </div>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>